import { render, staticRenderFns } from "./GoogleMediumBanner.vue?vue&type=template&id=37977bf5&"
import script from "./GoogleMediumBanner.vue?vue&type=script&lang=js&"
export * from "./GoogleMediumBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports